import { render, staticRenderFns } from "./QAUserAdd.vue?vue&type=template&id=5a4839b2&"
import script from "./QAUserAdd.vue?vue&type=script&lang=js&"
export * from "./QAUserAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports